const generateSrcset = (image, widths = []) => {
  const imageUrl = new URL(image["src"]);
  return widths.filter((width) => width <= image["width"]).map((width) => {
    imageUrl.searchParams.set("width", width.toString());
    return `${imageUrl.href} ${width}w`;
  }).join(", ");
}

const createImageElement = (image, classes, sizes, productTitle) => {
  const previewImage = image["preview_image"];
  const newImage = new Image(previewImage["width"], previewImage["height"]);
  newImage.className = classes;
  newImage.alt = image["alt"] || productTitle;
  newImage.sizes = sizes;
  newImage.src = previewImage["src"];
  newImage.srcset = generateSrcset(previewImage, [165, 360, 533, 720, 940, 1066]);
  newImage.loading="lazy"
  return newImage;
}

const formatCardMoney = (cents) => {
  if (typeof window.formatMoney === 'function') {
    return window.formatMoney(cents).replace('Rs.', '₹').replace('Rs', '₹');
  }
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2
  }).format((cents || 0) / 100);
}

const parsePriceTextToPaise = (value) => {
  if (!value) return null;
  const normalized = String(value).replace(/,/g, '').match(/(\d+(?:\.\d{1,2})?)/);
  if (!normalized) return null;
  return Math.round(parseFloat(normalized[1]) * 100);
}

const findVariantByFeaturedImagePathname = (variants, pathname) => {
  if (!pathname || !variants || !variants.length) return null;
  for (let i = 0; i < variants.length; i++) {
    const v = variants[i];
    const media = v.featured_media || v.featured_image;
    if (!media) continue;
    const src =
      media.src ||
      (media.preview_image && media.preview_image.src) ||
      (media.image && media.image.src);
    if (!src) continue;
    try {
      if (new URL(src, window.location.href).pathname === pathname) return v;
    } catch (e) {
      continue;
    }
  }
  return null;
};

const collectInitialCardState = (wrapper) => {
  const handleProduct = wrapper.dataset.product;
  const checkedSwatch = wrapper.querySelector('.js-color-swatches input:checked');
  const selectedVariantId = checkedSwatch ? checkedSwatch.dataset.variantId : null;
  const primaryImage = wrapper.querySelector('.media--first');
  const primaryImagePath = primaryImage ? new URL(primaryImage.currentSrc || primaryImage.src).pathname : null;
  const regularPriceNode = wrapper.querySelector('.price-item--regular');
  const displayedPricePaise = parsePriceTextToPaise(regularPriceNode ? regularPriceNode.textContent : null);
  const hiddenInputVariantId = wrapper.querySelector('.card__add-to-cart input[name="id"]')
    ? wrapper.querySelector('.card__add-to-cart input[name="id"]').value
    : null;

  if (!handleProduct) return;

  jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
    const expectedByHiddenInput = hiddenInputVariantId
      ? product.variants.find((v) => String(v.id) === String(hiddenInputVariantId))
      : null;
    const expectedByCheckedVariant = selectedVariantId
      ? product.variants.find((v) => String(v.id) === String(selectedVariantId))
      : null;
    const expectedByImage = primaryImagePath
      ? findVariantByFeaturedImagePathname(product.variants, primaryImagePath)
      : null;
    const expectedVariant = expectedByCheckedVariant || expectedByHiddenInput || expectedByImage || null;
    const expectedPricePaise = expectedVariant ? expectedVariant.price : null;

    if (expectedVariant && expectedPricePaise != null && expectedPricePaise !== displayedPricePaise) {
      updateCardPrice(wrapper, expectedVariant);
    }
  });
};

const updateCardPrice = (wrapper, variant) => {
  const priceRoot = wrapper.querySelector('.price');
  if (!priceRoot || !variant) return false;

  const moneyPrice = formatCardMoney(variant.price || 0);
  const compareAtPrice = variant.compare_at_price || 0;
  const moneyCompare = compareAtPrice > 0 ? formatCardMoney(compareAtPrice) : '';
  const isOnSale = compareAtPrice > (variant.price || 0);

  priceRoot.querySelectorAll('.price-item--regular, .price-item--sale').forEach((node) => {
    node.textContent = moneyPrice;
  });

  const compareNode = priceRoot.querySelector('.price__compare s');
  if (compareNode) {
    compareNode.textContent = moneyCompare;
  }

  priceRoot.classList.toggle('price--on-sale', isOnSale);
  return true;
}

const checkSwatches = () => {
  document.querySelectorAll('.js-color-swatches-wrapper').forEach(wrapper => {
    collectInitialCardState(wrapper);
    wrapper.querySelectorAll('.js-color-swatches input').forEach(input => {
      input.addEventListener('click', (event) => {
        const primaryImage = wrapper.querySelector(".media--first");
        const secondaryImage = wrapper.querySelector(".media--second");
        const handleProduct = wrapper.dataset.product;
        const selectedVariantId = event.currentTarget.dataset.variantId || null;
        
        if (event.currentTarget.checked && primaryImage) {
          wrapper.querySelector('.js-color-swatches-link').setAttribute('href', event.currentTarget.dataset.variantLink);
          if (wrapper.querySelector('.card__add-to-cart button[name="add"]')) {
            wrapper.querySelector('.card__add-to-cart button[name="add"]').setAttribute('aria-disabled', false);
            if (wrapper.querySelector('.card__add-to-cart button[name="add"] > span')) {
              wrapper.querySelector('.card__add-to-cart button[name="add"] > span').classList.remove('hidden');
              wrapper.querySelector('.card__add-to-cart button[name="add"] .sold-out-message').classList.add('hidden');
            }
            wrapper.querySelector('.card__add-to-cart input[name="id"]').value = event.currentTarget.dataset.variantId;
          }
          
          const currentColor = event.currentTarget.value;

          jQuery.getJSON(window.Shopify.routes.root + `products/${handleProduct}.js`, function(product) {
            const variant = product.variants.filter(item => item.featured_media != null && item.options.includes(currentColor))[0];
            const exactVariant = selectedVariantId
              ? product.variants.find(item => String(item.id) === String(selectedVariantId))
              : null;
            const activeVariant = exactVariant || variant;

            if (activeVariant && activeVariant["featured_media"]) {
              const newPrimaryImage = createImageElement(activeVariant["featured_media"], primaryImage.className, primaryImage.sizes, product.title);
              
              if (newPrimaryImage.src !== primaryImage.src) {
                let flag = false;
                if (secondaryImage) {
                  const secondaryImagePathname = new URL(secondaryImage.src).pathname;
                  const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

                  if (secondaryImagePathname == newPrimaryImagePathname) {
                    primaryImage.remove();
                    secondaryImage.classList.remove('media--second');
                    secondaryImage.classList.add('media--first');
                    flag = true;
                  } 
                }
                if (flag == false) {
                  primaryImage.animate({ opacity: [1, 0] }, { duration: 200, easing: "ease-in", fill: "forwards" }).finished;
                  setTimeout(function(){
                    primaryImage.replaceWith(newPrimaryImage);
                    newPrimaryImage.animate({ opacity: [0, 1] }, { duration: 200, easing: "ease-in" });
                    if (secondaryImage) {
                      secondaryImage.remove();                                    
                    }
                  }, 200);
                }
              }
            }
            updateCardPrice(wrapper, activeVariant);
          });
        }
      })
    })
  })
}

function colorSwatches() {
  checkSwatches();

  document.addEventListener('shopify:section:load', function () {
    checkSwatches();
  });
}

(function () {
colorSwatches();
})()